import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { QuoteCalculationComponent } from './quote-calculation.component';
import { QuoteCalculationRouteModule } from '../quote-calculation-route.module';
import { FormElementsModule } from '../../../form-elements';
import { CommonComponentsModule } from '../../../common-components';
import * as QuoteCalculation from '../../quote-calculation';
import { RecaptchaModule } from 'ng-recaptcha';


@NgModule({
  declarations: [
    QuoteCalculationComponent,
    QuoteCalculation.QuoteCalculationResultComponent,
    QuoteCalculation.QuoteVariantsComponent,
    QuoteCalculation.YourOptionsCalculationComponent,
    QuoteCalculation.QuotePlaybackComponent,
    QuoteCalculation.ProductQuoteComponent,
    QuoteCalculation.SelectedProductQuoteComponent,
    QuoteCalculation.CorpProductQuoteComponent,
    QuoteCalculation.FtrpProductQuoteComponent,
    QuoteCalculation.PartialProductQuoteComponent,
    QuoteCalculation.ProductQuoteComparisonComponent,
    QuoteCalculation.YourSaveQuoteComponent,
    QuoteCalculation.UserRegistrationComponent,
    QuoteCalculation.CashoutRetirementPlanComponent,
    QuoteCalculation.GmpAnnuityQuoteComponent
  ],
  imports: [
    CommonModule,
    FormElementsModule,
    CommonComponentsModule,
    FormsModule,
    ReactiveFormsModule,
    QuoteCalculationRouteModule,
    RecaptchaModule
  ]
})
export class QuoteCalculationModule { }
